// ContactContext.js
import React from "react";

const ContactContext = React.createContext();

export default ContactContext;
